import React from "react";
import { useParams } from "react-router-dom";

import SchemaNav from "features/Schema/SchemaNav";
import PageContent from "ui/PageContent";
import Panel from "ui/Panel";

import Table from "./Table";
import { useQueryStringSearch } from "ui/QueryStringSearch";

const SchemaViewList: React.FunctionComponent = () => {
  const { databaseId } = useParams();
  const [searchTerm, SearchInput] = useQueryStringSearch("q");

  return (
    <PageContent
      title="Schema Statistics"
      pageCategory="schema-views"
      pageName="index"
      featureNav={<SchemaNav databaseId={databaseId} />}
    >
      <Panel title="All Views" secondaryTitle={<SearchInput />}>
        <Table databaseId={databaseId} searchTerm={searchTerm} />
      </Panel>
    </PageContent>
  );
};

export default SchemaViewList;
